import { render, staticRenderFns } from "./Hoc-Tap.vue?vue&type=template&id=5afff628&scoped=true"
import script from "./Hoc-Tap.vue?vue&type=script&lang=js"
export * from "./Hoc-Tap.vue?vue&type=script&lang=js"
import style0 from "./Hoc-Tap.vue?vue&type=style&index=0&id=5afff628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afff628",
  null
  
)

export default component.exports